/**
 * THIS IS THE ENTRY POINT FOR THE CLIENT, JUST LIKE server.js IS THE ENTRY POINT FOR THE SERVER.
 */
import 'babel-polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
// import useScroll from 'scroll-behavior/lib/useStandardScroll';
import Raven from 'raven-js';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'react-router-redux';
import { Route, Redirect, Switch } from 'react-router-dom';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import atob from 'atob';
import createBrowserHistory from 'history/createBrowserHistory';
import createStore from '../src/redux/create';
import ApiClient from '../src/helpers/ApiClient';
import Root from '../modules/App/components/container';
import polyfills from './polyfills';
import withTracker from './ga-page-tracker';

const browserHistory = createBrowserHistory({ basename: '/v2' });


if (process.NODE_ENV === 'development') {
  // This enables hot reloading
  require('../src/styles/main.scss');
}

const enableSentry = __PRODUCTION__ || __STAGING__;

if (enableSentry) {
  const proxy = (context, method) => function () {
    const argz = Array.prototype.slice.apply(arguments);
    Raven.captureException(argz[0], {
      logger: 'console.error',
      extra: argz.slice(1, argz.length),
    });
    method.apply(context, argz);
  };

  console.error = proxy(console, console.error);

  window.addEventListener('unhandledrejection', (event) => {
    // Prevent error output on the console:
    event.preventDefault();
    if (event.reason) {
      console.error(event.reason);
    }
  });
}

try {
  polyfills();

  const b64DecodeUnicode = str =>
    decodeURIComponent(Array.prototype.map.call(atob(str), c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)).join(''));
  const client = new ApiClient();
  const dest = document.getElementById('content');
  const store = createStore(client, JSON.parse(b64DecodeUnicode(window.__data)), browserHistory);

  const { Account, App } = store.getState();

  client.setServerTime(Account.serverTime);

  if (Account.user && Account.user.id) {
    Raven.setUserContext({
      id: Account.user.id,
    });
  }

  if (enableSentry) {
    Raven
      .config(__PRODUCTION__ ? 'https://726d043c11f745e18b1e89ddd0f256d8@sentry.io/139915' : 'https://0a62d157a9e7421d9876762a6e8b5652@sentry.io/140213', {
        release: App.release,
        whitelistUrls: [/beta\.flightstats\.com/, /static\.flightstats\.com/],
        // Will cause a deprecation warning, but the demise of `ignoreErrors` is still under discussion.
        // See: https://github.com/getsentry/raven-js/issues/73
        ignoreErrors: [
          // ads
          'a.o.postMessage is not a function',
          // Random plugins/extensions
          'top.GLOBALS',
          // See: http://blog.errorception.com/2012/03/tale-of-unfindable-js-error.html
          'originalCreateNotification',
          'canvas.contentDocument',
          'MyApp_RemoveAllHighlights',
          'http://tt.epicplay.com',
          'Can\'t find variable: ZiteReader',
          'jigsaw is not defined',
          'ComboSearch is not defined',
          'http://loading.retry.widdit.com/',
          'atomicFindClose',
          // Facebook borked
          'fb_xd_fragment',
          // ISP "optimizing" proxy - `Cache-Control: no-transform` seems to reduce this. (thanks @acdha)
          // See http://stackoverflow.com/questions/4113268/how-to-stop-javascript-injection-from-vodafone-proxy
          'bmi_SafeAddOnload',
          'EBCallBackMessageReceived',
          // See http://toolbar.conduit.com/Developer/HtmlAndGadget/Methods/JSInjection.aspx
          'conduitPage',
          /* See here
          https://stackoverflow.com/questions/46050071/facebook-iframe-security-error-document-domain-raised-by-haspasswordfield
          And here
          https://github.com/getsentry/sentry/issues/5267
          bug fixed in chrome 61, older versions will continue to throw
          */
          'Blocked a frame with origin "https://beta.flightstats.com" from accessing a frame',
        ],
        ignoreUrls: [
          // Facebook flakiness
          /graph\.facebook\.com/i,
          // Facebook blocked
          /connect\.facebook\.net\/en_US\/all\.js/i,
          // Woopra flakiness
          /eatdifferent\.com\.woopra-ns\.com/i,
          /static\.woopra\.com\/js\/woopra\.js/i,
          // Chrome extensions
          /extensions\//i,
          /^chrome:\/\//i,
          // Other plugins
          /127\.0\.0\.1:4001\/isrunning/i,  // Cacaoweb
          /webappstoolbarba\.texthelp\.com\//i,
          /metrics\.itunes\.apple\.com\.edgesuite\.net\//i,
        ],
      })
      .install();
  }

  // const scrollingHistory = useScroll(() => browserHistory)();

  const AppRoot = () => (
    <Switch>
      <Route
        render={props => (
          <Root
            {...props}
            name='App'
          />
        )}
      />
    </Switch>
  );

  ReactDOM.render(
    <Provider store={store} key='provider'>
      <MuiThemeProvider muiTheme={getMuiTheme({ userAgent: 'all' })}>
        <ConnectedRouter history={browserHistory}>
          <Route component={withTracker(AppRoot, {/* additional attributes */ })} />
        </ConnectedRouter>
      </MuiThemeProvider>
    </Provider>, dest,
  );

  if (process.env.NODE_ENV !== 'production') {
    window.React = React; // enable debugger
  }
} catch (ex) {
  if (__CLIENT__) {
    Raven.captureException(ex);
  }
  console.log(ex);
}



// WEBPACK FOOTER //
// ./server/client.js